<template>
  <DefaultTemplate positionNavNextTo="right" type="signup">
    <div class="box-container pd-y-1">
      <Header title="ตั้งค่ารหัสผ่านใหม่" class="forgetPass" />
      <el-form
        label-position="top"
        class="text-left pd-b-1 box-sandemail"
        ref="resetPssword"
        :model="resetPssword"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="รหัสผ่านใหม่" prop="pass">
              <el-input type="password" v-model="resetPssword.pass" autocomplete="off" @keyup.enter.native="submitForm('resetPssword')"></el-input>
            </el-form-item>
            <el-form-item label="ยืนยันรหัสผ่านใหม่" prop="checkPass">
              <el-input type="password" v-model="resetPssword.checkPass" autocomplete="off"  @keyup.enter.native="submitForm('resetPssword')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="pd-y-3">
            <el-button type="primary" class="width-100" round @click="submitForm('resetPssword')">ขอรหัสผ่านใหม่</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("กรุณากรอกรหัสผ่าน"));
      } else if (value.length < 8) {
        callback(new Error("รหัสผ่านต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร"));
      } else {
        if (this.resetPssword.checkPass !== "") {
          this.$refs.resetPssword.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("กรุณากรอกรหัสผ่าน"));
      } else if (value !== this.resetPssword.pass) {
        callback(new Error("รหัสผ่านไม่ตรงกัน"));
      } else {
        callback();
      }
    };
    return {
      resetPssword: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            code: this.$route.params.code,
            password: this.resetPssword.checkPass,
          };
          HTTP.post(`reset/password`, obj)
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "เปลี่ยนรหัสผ่านสำเร็จ",
                  type: "success",
                  duration: 4000,
                });
                this.$router.push(`/signin`);
              } else {
                this.alertFailError();
              }
            })
            .catch((e) => {
              this.alertCatchError(e);
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
